export enum MessageCode {
  AuthorizeOperationCardCode = 'AUTHORIZE_OPERATION_CARD_CODE',
  AuthorizeOperationPush = 'AUTHORIZE_OPERATION_PUSH',
  AuthorizeOperationSms = 'AUTHORIZE_OPERATION_SMS',
  CancelProcess = 'CANCEL_PROCESS',
  ChooseAccount = 'CHOOSE_ACCOUNT',
  DownloadingTransactions = 'DOWNLOADING_TRANSACTIONS',
  DownloadingUserInformation = 'DOWNLOADING_USER_INFORMATION',
  Error = 'ERROR',
  GetCurrentMessage = 'GET_CURRENT_MESSAGE',
  ImageIds = 'IMAGE_IDS',
  Login = 'LOGIN',
  Login2faPush = 'LOGIN_2FA_PUSH',
  Logout = 'LOGOUT',
  RetryAuthorizeOperationPush = 'RETRY_AUTHORIZE_OPERATION_PUSH',
  AmlPopup = 'AML_POPUP',
  ConfirmTransactionDownload = 'CONFIRM_TRANSACTIONS_DOWNLOAD'
}

export interface MessageError {
  exceptionDetails?: string;
  source: 'USER' | 'FALLBACK';
}

export interface AccountInfo {
  accountName: string;
  accountShortNumber: string;
  accountNumber: string;
}

export interface ImageIds {
  chooseOneImage: boolean;
  details: { imageId: string; url: string }[];
}

export interface Message {
  messageCode: MessageCode;
  value: string;
  object?: AccountInfo[] | ImageIds | MessageError | string;
}
